import { useLocation, useNavigate } from 'react-router-dom';

const useTabsNavigation = (sectionOptions, principalHash) => {
  const { hash, pathname } = useLocation();

  const firstHash = !!hash.split('#')[1] ? hash.split('#')[1] : principalHash ? principalHash : sectionOptions[0].key;
  const secondHash = !!hash.split('#')[2] ? hash.split('#')[2] : sectionOptions[0].key;
  const navigate = useNavigate();

  const onTabChange = section => {
    navigate(`${pathname}#${section}`);
  };

  const onSecondTabChange = section => {
    navigate(`${pathname}#${firstHash}#${section}`);
  };

  return {
    hash: sectionOptions.some(({ key }) => key === firstHash.replace('#', '')) ? firstHash.replace('#', '') : sectionOptions[0].key,
    secondHash: sectionOptions.some(({ key }) => key === secondHash.replace('#', ''))
      ? secondHash.replace('#', '')
      : sectionOptions[0].key,
    onTabChange,
    onSecondTabChange
  };
};

export default useTabsNavigation;
